var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isErrorPage)?_c('ErrorPage',{attrs:{"error":_vm.pageError}}):_c(_vm.currentLayout,{tag:"component"})
}
var staticRenderFns = []

export { render, staticRenderFns }